import React from 'react';
import i18n from 'i18n';
import mansvg from 'assets/img/man.svg';

const AboutMockService = () => {
  return (
    <div>
      <h2 className={'mb-5'}>{i18n.t('wizard:menu.about')}</h2>
      <p>{i18n.t('wizard:details.aboutMockService')}</p>
      <div className="text-center" style={{ marginTop: 65 }}>
        <img src={mansvg} alt={'man'} className={'img-fluid'} />
      </div>
    </div>
  );
};

export default AboutMockService;
